import {
  FormControl,
  InputLabel,
  MenuItem,
  OutlinedInput,
  Select,
} from '@mui/material';
import { COMMON_TIMEZONES, useTimezoneStore } from 'src/store/timezoneStore';

const ITEM_HEIGHT = 48;
const ITEM_PADDING_TOP = 8;
const MenuProps = {
  PaperProps: {
    style: {
      maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
      width: 250,
    },
  },
};

export const TimezoneToggle = () => {
  const { timezone, setTimezone } = useTimezoneStore();

  const systemDefaultTimezone =
    Intl.DateTimeFormat().resolvedOptions().timeZone;

  const options = [
    {
      value: systemDefaultTimezone,
      label: `System (${systemDefaultTimezone})`,
    },
    ...COMMON_TIMEZONES.filter((tz) => tz.value !== systemDefaultTimezone),
  ];

  const onChange = (event: any) => {
    setTimezone(event.target.value);
  };

  return (
    <FormControl sx={{ m: 1, width: 250 }}>
      <InputLabel id='timezone-label'>Timezone</InputLabel>
      <Select
        labelId='timezone-label'
        id='timezone'
        value={timezone}
        onChange={onChange}
        input={<OutlinedInput id='timezone' label='Timezone' />}
        MenuProps={MenuProps}
        size='small'
      >
        {options.map((option) => (
          <MenuItem key={option.value} value={option.value}>
            {option.label}
          </MenuItem>
        ))}
      </Select>
    </FormControl>
  );
};
